import { render, staticRenderFns } from "./tasksCanban.vue?vue&type=template&id=c4dd8b34&scoped=true&"
import script from "./tasksCanban.vue?vue&type=script&lang=js&"
export * from "./tasksCanban.vue?vue&type=script&lang=js&"
import style0 from "./tasksCanban.vue?vue&type=style&index=0&id=c4dd8b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dd8b34",
  null
  
)

export default component.exports